require('widgets/common')
require('slick-carousel')
require('@173js/ui/preventEmptyHrefClick')

var detector = require('widgets/detector')
  , pingjs = require('widgets/ping.js')
  , Video = require('widgets/Video')

var $ = require('jquery')
  , win = $(window)

$(function() {

  var modVideo = $('.mod-video')
    , links = $('.mod-video-tab').find('.item a')
    , h1Section = $('h1')
    , headTitle = $('title')
    , gameName = modVideo.data('game-name')
    , defaultState = {
        title: h1Section.text()
      , playUrl: modVideo.data('default-play-url')
      , vid: modVideo.data('default-vid')
      }
    , currentVideoId = defaultState.vid
    , modIntroVideo = $('.mod-intro-video')

  var video = new Video({
    videoUrl: defaultState.playUrl
  , ignoreAdvertise: false
  , autoPlay: false
  , width: '100%'
  , height: '100%'
  })

  modVideo.html(video.toHTML())

  function renderVideoFromState(state) {
    state = state || defaultState
    var title = state.title

    links.removeClass('current')

    links.filter("[data-play-url='" + state.playUrl + "']").addClass('current')

    h1Section.text(title)
    headTitle.text([gameName, title].join('_'))

    var video = new Video({
      videoUrl: state.playUrl
    , ignoreAdvertise: false
    , autoPlay: false
    , width: '100%'
    , height: '100%'
    })

    modVideo.html(video.toHTML())

    var stateVid = state.vid
    currentVideoId = stateVid

    $.get('/video-userInfo-' + stateVid + '.html')
      .done(function(resp) {
        if (!resp.status || !resp.html) { return }
        if (currentVideoId !== stateVid) { return }
        modIntroVideo.html(resp.html)
      })
  }

  if (detector.hasPushState()) {
    win.on('popstate', function(e) {
      var currentState = history.state
      renderVideoFromState(currentState)
    })
  }

  links.click(function(e) {
    var el = $(e.currentTarget)
      , pageHref = el.data('page-href')

    if (detector.hasPushState()) {
      e.preventDefault()
    } else {
      return
    }

    var title = el.attr('title')

    var state = {
      title: title
    , playUrl: el.data('play-url')
    , vid: el.data('vid')
    }

    renderVideoFromState(state)
    history.pushState(state, title, pageHref)
    pingjs.trackPageview()
  })

})

$(function() {

  $('.mod-game').each(function() {
    var section = $(this)
    section.on('click', '.btn-more', function(e) {
      var modUser = section.find('.mod-user')
        , beExpanded = !modUser.hasClass('mod-user-ex')

      modUser
        .toggleClass('mod-user-ex', beExpanded)
        .find('.abstract-intro')[beExpanded ? 'hide': 'show']().end()
        .find('.detail-intro')[beExpanded ? 'show': 'hide']().end()

      section.find('.btn-more')
        .toggleClass('btn-more-ex', beExpanded)
        .find('.down')[beExpanded ? 'hide': 'show']().end()
        .find('.up')[beExpanded ? 'show': 'hide']().end()
    })
  })

  // slick slide
  var slickPast = $('.slick-past')

  if (slickPast.length) {
    var slick = slickPast.slick({
      dots: false
    , infinite: false
    , speed: 300
    , slidesToShow: 4
    , slidesToScroll: 4
    })

    var currentItem = slickPast.find('.current')
      , slickItems = slickPast.find('.item')

    if (currentItem.length) {
      var slickItem = currentItem.closest('.item', slickPast)
      slick.slick('slickGoTo', slickItems.index(slickItem))
    }
  }

  var panel = $('.scroll-pane')

  function makePanelScrollable() {
    panel.jScrollPane({
      mouseWheelSpeed:100
    , hideFocus:true
    })
  }

  makePanelScrollable()
  win.resize(makePanelScrollable)
})
